import React from 'react';
import { AlertColor } from '@mui/material/Alert';
import AlertMessage from 'components/AlertMessage/AlertMessage';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';

export type ValidationErrorCode = 'required' | 'duplicate' | 'min';

export type ValidationError = {
  severity: AlertColor;
  message: string;
  index?: number;
  code?: ValidationErrorCode;
};

export type IndexedValidationError = ValidationError & { index: number };

interface ValidationErrorsProps {
  errors?: ValidationError[];
}

type Props = ValidationErrorsProps;

const ValidationErrors = ({ errors }: Props) => {
  if (!errors?.length) {
    return null;
  }

  return (
    <>
      {errors.length === 1 ? (
        <AlertMessage severity={errors[0].severity}>{errors[0].message}</AlertMessage>
      ) : (
        <AlertMessage severity={errors[0].severity}>
          <AlertTitle>Validation Errors</AlertTitle>
          <Box component='ul' sx={{ pl: 2.5 }}>
            {errors.map((error, index) => (
              <li key={`${index}_${error.index ?? error.message}`}>
                <Typography>{error.message}</Typography>
              </li>
            ))}
          </Box>
        </AlertMessage>
      )}
    </>
  );
};

export default ValidationErrors;
